// Canvas operation related messages
export default {
  deleteNodeFailed: "Deletion failed, please refresh the page and try again!",
  operationFailed: "Operation failed, please refresh the page and try again!",
  nodeRepeatWarning: "This node appears {count} times in the canvas!",
  noMoreNodes: "No more nodes!",
  doubleClickViewTransaction: "Double click to view transaction details",
  addressOwnership: "This is address ownership",
};
